module.exports = {
  UPDATE_CLIENT_CONFIG:'UPDATE_CLIENT_CONFIG',
  UPDATE_REMOTE_CONFIG:'UPDATE_REMOTE_CONFIG',
  UPDATE_SERVICES:'UPDATE_SERVICES',

  SET_HEADER:'SET_HEADER',

  LOGOUT_USER:'LOGOUT_USER',
  UPDATE_USER:'UPDATE_USER'
};



// WEBPACK FOOTER //
// ./src/flux/constants/RemoteConstants.js